export default __webpack_public_path__ + "static/media/2001-AMcover.1bf84b2a.png";